(function () {
  'use strict';

  function initCartLiaisonFrigorifique(form) {
    if (!form) {
      console.warn('Cart liaison form not found');
      return;
    }

    const sectionId = form.dataset.sectionId;
    const moneyFormat = form.dataset.moneyFormat || '{{amount}}';

    // Extract variant data from form data attributes
    // Use getAttribute because data attributes with numbers don't convert properly to camelCase
    const variantData = {
      '4m_a': {
        id: parseInt(form.getAttribute('data-variant-4m-a') || '0', 10),
        price: parseInt(form.getAttribute('data-variant-4m-a-price') || '0', 10),
        available: form.getAttribute('data-variant-4m-a-available') === 'true'
      },
      '4m_b': {
        id: parseInt(form.getAttribute('data-variant-4m-b') || '0', 10),
        price: parseInt(form.getAttribute('data-variant-4m-b-price') || '0', 10),
        available: form.getAttribute('data-variant-4m-b-available') === 'true'
      },
      '6m_a': {
        id: parseInt(form.getAttribute('data-variant-6m-a') || '0', 10),
        price: parseInt(form.getAttribute('data-variant-6m-a-price') || '0', 10),
        available: form.getAttribute('data-variant-6m-a-available') === 'true'
      },
      '6m_b': {
        id: parseInt(form.getAttribute('data-variant-6m-b') || '0', 10),
        price: parseInt(form.getAttribute('data-variant-6m-b-price') || '0', 10),
        available: form.getAttribute('data-variant-6m-b-available') === 'true'
      },
      'connector_a': {
        id: parseInt(form.getAttribute('data-variant-connector-a') || '0', 10),
        price: parseInt(form.getAttribute('data-variant-connector-a-price') || '0', 10),
        available: form.getAttribute('data-variant-connector-a-available') === 'true'
      },
      'connector_b': {
        id: parseInt(form.getAttribute('data-variant-connector-b') || '0', 10),
        price: parseInt(form.getAttribute('data-variant-connector-b-price') || '0', 10),
        available: form.getAttribute('data-variant-connector-b-available') === 'true'
      }
    };

    // Debug: log variant data to help diagnose issues
    // console.log('Cart liaison variant data loaded:', variantData);

    const lengthSelect = form.querySelector('.liaison-total-length-select');
    const modelSelect = form.querySelector('.liaison-model-select');
    const compositionEl = form.querySelector('.cart-liaison-composition');
    const priceEl = form.closest('.cart-liaison-frigorifique__product')?.querySelector('.cart-liaison-total-price');
    const submitButton = form.querySelector('button[type="submit"]');

    // Check if required elements exist
    if (!lengthSelect || !modelSelect || !compositionEl) {
      console.error('Required elements not found for cart liaison form');
      return;
    }

    // Prevent any default form submission behavior
    form.setAttribute('onsubmit', 'return false;');
    form.setAttribute('novalidate', 'novalidate');

    // Calculate composition based on total length and model
    function calculateComposition(totalLength, model) {
      const composition = {
        items: [],
        totalPrice: 0,
        description: ''
      };

      if (!totalLength || !model) {
        return composition;
      }

      const length = parseInt(totalLength, 10);
      const modelKey = model === 'a' ? 'a' : 'b';

      let liaison4mKey = '4m_' + modelKey;
      let liaison6mKey = '6m_' + modelKey;
      let connectorKey = 'connector_' + modelKey;

      // Check if variants are available
      const variant4m = variantData[liaison4mKey];
      const variant6m = variantData[liaison6mKey];
      const variantConnector = variantData[connectorKey];

      // Debug: log variant data
      // console.log('Variant data check:', {
      //   modelKey,
      //   liaison4mKey,
      //   liaison6mKey,
      //   connectorKey,
      //   variant4m,
      //   variant6m,
      //   variantConnector
      // });

      if (!variant4m || !variant4m.id || variant4m.id === 0) {
        console.warn('4m liaison variant not found for model', modelKey, variant4m);
        return composition;
      }
      if (!variant6m || !variant6m.id || variant6m.id === 0) {
        console.warn('6m liaison variant not found for model', modelKey, variant6m);
        return composition;
      }

      // Check availability only if the variant exists
      if (variant4m.available === false) {
        console.warn('4m liaison variant not available for model', modelKey);
        return composition;
      }
      if (variant6m.available === false) {
        console.warn('6m liaison variant not available for model', modelKey);
        return composition;
      }

      let descriptionParts = [];

      switch (length) {
        case 4:
          // 1 liaison de 4m
          composition.items.push({
            id: variant4m.id,
            quantity: 1
          });
          composition.totalPrice += variant4m.price;
          descriptionParts.push('1 x 4m connection');
          break;

        case 6:
          // 1 liaison de 6m
          composition.items.push({
            id: variant6m.id,
            quantity: 1
          });
          composition.totalPrice += variant6m.price;
          descriptionParts.push('1 x 6m connection');
          break;

        case 8:
          // 2 liaisons de 4m + 1 connecteur
          if (!variantConnector || !variantConnector.id || variantConnector.id === 0) {
            console.warn('Connector variant not found for model', modelKey, variantConnector);
            return composition;
          }
          if (variantConnector.available === false) {
            console.warn('Connector variant not available for model', modelKey);
            return composition;
          }
          composition.items.push({
            id: variant4m.id,
            quantity: 2
          });
          composition.items.push({
            id: variantConnector.id,
            quantity: 1
          });
          composition.totalPrice += (variant4m.price * 2) + variantConnector.price;
          descriptionParts.push('2 x 4m connections');
          descriptionParts.push('1 connector');
          break;

        case 10:
          // 1 liaison de 4m + 1 liaison de 6m + 1 connecteur
          if (!variantConnector || !variantConnector.id || variantConnector.id === 0) {
            console.warn('Connector variant not found for model', modelKey, variantConnector);
            return composition;
          }
          if (variantConnector.available === false) {
            console.warn('Connector variant not available for model', modelKey);
            return composition;
          }
          composition.items.push({
            id: variant4m.id,
            quantity: 1
          });
          composition.items.push({
            id: variant6m.id,
            quantity: 1
          });
          composition.items.push({
            id: variantConnector.id,
            quantity: 1
          });
          composition.totalPrice += variant4m.price + variant6m.price + variantConnector.price;
          descriptionParts.push('1 x 4m connection');
          descriptionParts.push('1 x 6m connection');
          descriptionParts.push('1 connector');
          break;

        case 12:
          // 2 liaisons de 6m + 1 connecteur
          if (!variantConnector || !variantConnector.id || variantConnector.id === 0) {
            console.warn('Connector variant not found for model', modelKey, variantConnector);
            return composition;
          }
          if (variantConnector.available === false) {
            console.warn('Connector variant not available for model', modelKey);
            return composition;
          }
          composition.items.push({
            id: variant6m.id,
            quantity: 2
          });
          composition.items.push({
            id: variantConnector.id,
            quantity: 1
          });
          composition.totalPrice += (variant6m.price * 2) + variantConnector.price;
          descriptionParts.push('2 x 6m connections');
          descriptionParts.push('1 connector');
          break;

        default:
          return composition;
      }

      composition.description = descriptionParts.join(' + ');
      return composition;
    }

    // Update UI based on selection
    function updateUI() {
      const totalLength = lengthSelect.value;
      const model = modelSelect.value;

      if (!totalLength) {
        // Reset to initial state
        modelSelect.setAttribute('disabled', 'disabled');
        modelSelect.value = '';
        compositionEl.innerHTML = '<span class="cart-liaison-composition-placeholder"></span>';
        if (priceEl) {
          priceEl.innerHTML = '<span class="cart-liaison-price-placeholder">Select a length</span>';
        }
        if (submitButton) {
          submitButton.setAttribute('disabled', 'disabled');
        }
        return;
      }

      // Enable model select when length is selected
      modelSelect.removeAttribute('disabled');

      if (!model) {
        compositionEl.innerHTML = '<span class="cart-liaison-composition-placeholder">Select a model</span>';
        if (priceEl) {
          priceEl.innerHTML = '<span class="cart-liaison-price-placeholder">Select a model</span>';
        }
        if (submitButton) {
          submitButton.disabled = true;
        }
        return;
      }

      // Calculate composition
      const composition = calculateComposition(totalLength, model);

      if (composition.items.length === 0) {
        compositionEl.innerHTML = '<span class="cart-liaison-composition-placeholder" style="color: red;">Configuration unavailable</span>';
        if (priceEl) {
          priceEl.innerHTML = '<span class="cart-liaison-price-placeholder">-</span>';
        }
        if (submitButton) {
          submitButton.disabled = true;
        }
        return;
      }

      // Update composition display
      compositionEl.innerHTML = '<strong>Composition:</strong> ' + composition.description;

      // Update price display
      if (priceEl) {
        let formattedPrice;
        if (window.Shopify && window.Shopify.formatMoney) {
          formattedPrice = window.Shopify.formatMoney(composition.totalPrice, moneyFormat);
        } else {
          formattedPrice = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2
          }).format(composition.totalPrice / 100);
        }
        priceEl.innerHTML = '+' + formattedPrice;
      }

      // Enable submit button
      if (submitButton) {
        submitButton.disabled = false;
      }
    }

    // Event listeners
    lengthSelect.addEventListener('change', updateUI);
    modelSelect.addEventListener('change', updateUI);

    // Initialize UI state
    updateUI();

    // Handle form submission
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      try {
        const totalLength = lengthSelect.value;
        const model = modelSelect.value;

        if (!totalLength || !model) {
          alert('Please select a length and a model.');
          return false;
        }

        const composition = calculateComposition(totalLength, model);

        if (composition.items.length === 0) {
          alert('This configuration is not available. Please choose another option.');
          return false;
        }

        // Disable button and show loading
        if (submitButton) {
          submitButton.classList.add('btn--loading');
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.disabled = true;
        }

        // Use theme utilities if available
        const config = window.FoxTheme && window.FoxTheme.utils
          ? window.FoxTheme.utils.fetchConfig('javascript')
          : { headers: { 'Content-Type': 'application/json' } };

        const cartAddUrl = window.FoxTheme && window.FoxTheme.routes
          ? window.FoxTheme.routes.cart_add_url
          : '/cart/add.js';

        // Get section ID for cart drawer refresh
        const cartDrawer = document.getElementById('CartDrawer');
        const sectionIdForRequest = cartDrawer ? cartDrawer.getAttribute('data-section-id') : null;

        // Prepare request with multiple items
        const requestBody = {
          items: composition.items
        };

        // Request sections for cart drawer update
        if (sectionIdForRequest) {
          requestBody.sections = sectionIdForRequest;
        }

        fetch(cartAddUrl, {
          ...config,
          method: 'POST',
          body: JSON.stringify(requestBody)
        })
          .then(response => response.json())
          .then(async (parsedState) => {
            // Get updated cart
            const cartUrl = window.FoxTheme && window.FoxTheme.routes
              ? window.FoxTheme.routes.cart_url
              : '/cart.js';

            const cartConfig = window.FoxTheme && window.FoxTheme.utils
              ? window.FoxTheme.utils.fetchConfig()
              : {};

            const cartJson = await (await fetch(cartUrl, cartConfig)).json();
            cartJson['sections'] = parsedState['sections'] || {};

            // Trigger cart update via pubsub
            if (window.FoxTheme && window.FoxTheme.pubsub) {
              const cartUpdateEvent = window.FoxTheme.pubsub.PUB_SUB_EVENTS?.cartUpdate || 'cart-update';
              window.FoxTheme.pubsub.publish(cartUpdateEvent, { cart: cartJson });
            }

            // Listen for cart:updated event to reinitialize Trustpilot widget
            const handleCartUpdated = () => {
              setTimeout(() => {
                if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
                  const trustpilotWidget = document.querySelector('.trustpilot-widget');
                  if (trustpilotWidget) {
                    try {
                      window.Trustpilot.loadFromElement(trustpilotWidget, true);
                    } catch (e) {
                      console.warn('Trustpilot widget reinitialization failed:', e);
                    }
                  }
                }
              }, 300);
            };

            document.addEventListener('cart:updated', handleCartUpdated, { once: true });

            // Dispatch product added event
            document.dispatchEvent(new CustomEvent('product-ajax:added', {
              detail: { product: parsedState }
            }));

            // Show cart drawer if it exists
            if (cartDrawer && cartDrawer.show) {
              cartDrawer.show();
            }
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            if (submitButton) {
              submitButton.classList.remove('btn--loading');
              submitButton.removeAttribute('aria-disabled');
              submitButton.disabled = false;
            }
          });

        return false;
      } catch (err) {
        console.error('Error in form submission handler:', err);
        if (submitButton) {
          submitButton.classList.remove('btn--loading');
          submitButton.removeAttribute('aria-disabled');
          submitButton.disabled = false;
        }
        return false;
      }
    }, true); // Use capture phase
  }

  // Function to initialize all forms
  function initializeAllForms() {
    document.querySelectorAll('[id^="CartLiaisonForm-"]').forEach(form => {
      // Check if already initialized (avoid double initialization)
      if (!form.dataset.initialized) {
        initCartLiaisonFrigorifique(form);
        form.dataset.initialized = 'true';
      }
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllForms);
  } else {
    // DOM already loaded
    initializeAllForms();
  }

  // Re-initialize when cart is updated (for case 2: when climatiseur is added)
  document.addEventListener('cart:updated', function () {
    // Small delay to ensure DOM is updated
    setTimeout(initializeAllForms, 100);
  });

  // Also listen to cart update events from pubsub
  if (window.FoxTheme && window.FoxTheme.pubsub) {
    const cartUpdateEvent = window.FoxTheme.pubsub.PUB_SUB_EVENTS?.cartUpdate || 'cart-update';
    document.addEventListener(cartUpdateEvent, function () {
      setTimeout(initializeAllForms, 100);
    });
  }

  // Also expose function globally for dynamic initialization
  window.initCartLiaisonFrigorifique = initCartLiaisonFrigorifique;
})();
